import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ExportToCsv } from 'export-to-csv';
import envConfig from '../../../config';
import {
  bulkChurnEntity,
  bulkEditEntity,
  bulkPulseUpdate,
  bulkUploadEntity,
  getBulkUploadHistory,
  getUploadErrorReport,
} from '../../routines';

import { request } from '../../../common/util/RestClient';
import SUCCESS_MESSAGES from '../../../common/constants/SuccessMessagesConstants';

export function* bulkUploadHistorySaga() {
  try {
    const URL = `${envConfig.APIG_URL}core/entity/bulk/entity-upload/history`;
    const reqConfig = {
      method: 'GET',
    };
    const response = yield call(request, URL, reqConfig);
    yield put(getBulkUploadHistory.success(response));
  } catch (error) {
    yield put(getBulkUploadHistory.failure({ error }));
  }
}

export function* bulkUploadEntitySaga({ payload }) {
  try {
    const { data, level, config } = payload;
    const URL = `${envConfig.APIG_URL}core/entity/bulk`;
    const reqConfig = {
      method: 'POST',
      payload: { data, config, type: 'entityBulkUpload', level },
    };
    const response = yield call(request, URL, reqConfig);
    yield put(
      bulkUploadEntity.success({
        response,
      })
    );
    yield put(getBulkUploadHistory.trigger());
  } catch (error) {
    yield put(bulkUploadEntity.failure({ error }));
  }
}
export function* bulkEditEntitySaga({ payload }) {
  try {
    const { updates, level } = payload;
    const URL = `${envConfig.APIG_URL}core/entity/bulk`;
    const config = {
      method: 'POST',
      payload: { data: updates, type: 'entity', level },
    };
    const response = yield call(request, URL, config);
    payload.onSuccess();
    yield put(
      bulkEditEntity.success({
        response,
        successMessage: SUCCESS_MESSAGES.BULK_UPDATE_SUBMITTED,
      })
    );
  } catch (error) {
    yield put(bulkEditEntity.failure({ error }));
  }
}
export function* bulkPulseUpdateSaga({ payload }) {
  try {
    const { updates, level } = payload;
    const URL = `${envConfig.APIG_URL}core/entity/bulk`;
    const config = {
      method: 'POST',
      payload: { data: updates, type: 'pulse', level },
    };
    const response = yield call(request, URL, config);
    payload.onSuccess();
    yield put(
      bulkPulseUpdate.success({
        response,
        successMessage: SUCCESS_MESSAGES.BULK_UPDATE_SUBMITTED,
      })
    );
  } catch (error) {
    yield put(bulkPulseUpdate.failure({ error }));
  }
}

export function* bulkChurnEntitySaga({ payload }) {
  try {
    const { updates, level } = payload;
    const URL = `${envConfig.APIG_URL}core/entity/bulk`;
    const config = {
      method: 'POST',
      payload: { data: updates, type: 'churn', level },
    };
    const response = yield call(request, URL, config);
    payload.onSuccess();
    yield put(
      bulkChurnEntity.success({
        response,
        successMessage: SUCCESS_MESSAGES.BULK_UPDATE_SUBMITTED,
      })
    );
  } catch (error) {
    yield put(bulkChurnEntity.failure({ error }));
  }
}

export function* getUploadErrorReportSaga({ payload }) {
  try {
    const { jobId } = payload;
    const URL = `${envConfig.APIG_URL}core/entity/bulk/${jobId}/items?status=10,30`; // failed, skipped
    const reqConfig = {
      method: 'GET',
    };
    const response = yield call(request, URL, reqConfig);

    const csvData = response.data.reverse().map((item) => {
      const failureAttempts = {};
      const errors = item.failure_reason.failures.map((failure) => {
        if (Array.isArray(failure)) {
          return failure.error.join('\n');
        }
        return failure.error;
      });
      errors.forEach((error, index) => {
        failureAttempts[`ATTEMPT_${index + 1}`] = error;
      });

      return {
        ...item.update_body,
        Errors: errors.join('\n'),
        // Errors:
      };
    });

    const csvExporter = new ExportToCsv({
      filename: `${jobId}_velaris_upload_error_log`,
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });
    csvExporter.generateCsv(csvData);
  } catch (error) {
    yield put(getUploadErrorReport.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(bulkEditEntity.TRIGGER, bulkEditEntitySaga),
    takeLatest(bulkPulseUpdate.TRIGGER, bulkPulseUpdateSaga),
    takeLatest(bulkChurnEntity.TRIGGER, bulkChurnEntitySaga),
    takeLatest(bulkUploadEntity.TRIGGER, bulkUploadEntitySaga),
    takeLatest(getBulkUploadHistory.TRIGGER, bulkUploadHistorySaga),
    takeLatest(getUploadErrorReport.TRIGGER, getUploadErrorReportSaga),
  ]);
}
